import {
  BROWSER_STORAGE_BASE_NAME,
  DOC_FORMAT_CONFIG_VALUES,
  MAX_SHARE_LINK_COUNT,
  USE_REACT_ROUTER
} from '../define/global';

class LocalStorageManager {
  constructor() {
    this.key = USE_REACT_ROUTER
      ? `${BROWSER_STORAGE_BASE_NAME}_${DOC_FORMAT_CONFIG_VALUES.sdk.documnetType.toUpperCase()}`
      : BROWSER_STORAGE_BASE_NAME;
    this.maxCount = MAX_SHARE_LINK_COUNT;
  }

  storageAvailable() {
    var storage;
    try {
      storage = window['localStorage'];
      var x = `__${this.key}__storage_test__`;
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        storage &&
        storage.length !== 0
      );
    }
  }

  addItem(item) {
    let current = this._getStorage();
    if (!current) {
      current = {};
      current[this.key] = [item];
    } else {
      if (current[this.key].findIndex((ele) => ele === item) < 0) {
        current[this.key].unshift(item);
        if (current[this.key].length > this.maxCount) {
          current[this.key].length = this.maxCount;
        }
      } else {
        return;
      }
    }
    window.localStorage.setItem(this.key, JSON.stringify(current));
  }

  getItem() {
    let current = this._getStorage();
    if (!current) {
      return [];
    }
    return current[this.key].filter((item) => typeof item === 'string');
  }

  _getStorage() {
    return JSON.parse(window.localStorage.getItem(this.key));
  }
}

export default LocalStorageManager;
